import config from 'services/table/const';
import Action from './action';
import { formatDate } from 'utilities/common';

let table = { ...config };
table.url = '/tms/contract';
table.columns = {
  code: {
    title: 'Kode',
    sortable: true,
    alias: 'id',
    width: 120,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.code}
          </div>
          {row?.order?.ref_code && (
            <small className="info">REF: {row?.order?.ref_code}</small>
          )}
          <div>
            <small className="info text-uppercase">
              {formatDate(row?.created_at)}
            </small>
          </div>
        </div>
      );
    },
  },

  shipper: {
    title: 'Pengirim',
    sortable: true,
    alias: 'shipper.name',
    width: 80,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.shipper?.name}
          </div>
          {row?.customer?.name && (
            <small className="info text-uppercase">
              CUST: {row?.customer?.name}
            </small>
          )}
        </div>
      );
    },
  },

  shipments: {
    title: 'Total Shipment',
    sortable: false,
    alias: 'shipments.length',
    width: 80,
    class: 'text-center',
    classHeader: 'text-center',
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.shipments?.length}
          </div>
        </div>
      );
    },
  },

  service_type: {
    title: 'Service',
    width: 120,
    component: (row) => {
      return !row?.service_type ? null : (
        <div className="table-col row align-items-center">
          <div className="col-3">
            <img
              src={row?.service_type?.service?.image}
              height={40}
              width={40}
              alt=""
            />
          </div>
          <div className="col-9">
            <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
              {row?.service_type?.name}
            </div>
            <small className="info text-uppercase">
              {row?.service_type?.service?.name}
            </small>
          </div>
        </div>
      );
    },
  },

  vendor: {
    title: 'Vendor',
    alias: 'vendor.name',
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.vendor?.name || '-'}
          </div>
        </div>
      );
    },
  },

  periode: {
    title: 'Periode',
    width: 120,
    class: 'text-center',
    classHeader: 'text-center',
    component: (row) => {
      return (
        <div className="fs-8 ">
          {formatDate(row?.periode_start_at, 'DD/MM/YYYY')} s/d.{' '}
          {formatDate(row?.periode_end_at, 'DD/MM/YYYY')}
        </div>
      );
    },
  },

  price: {
    title: 'Harga',
    format_number: true,
    sortable: false,
    width: 70,
    class: 'text-end',
    classHeader: 'text-end',
    visible: 'nvo.tms.pricing',
  },

  document_status: {
    title: 'Status',
    sortable: false,
    class: 'text-center',
    classHeader: 'text-center',
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <span className={`badge status-${row?.document_status}-lt ms-auto `}>
            {row?.document_status
              ?.replace('_', ' ')
              ?.replace('console', 'transit')}
          </span>
          {row?.current_hub?.name && (
            <small className="info text-uppercase">
              CL: {row?.current_hub?.name}
            </small>
          )}
        </div>
      );
    },
  },

  action: {
    title: '',
    sortable: false,
    width: 20,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};

export default table;
